import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
@Injectable({
    providedIn: 'root'
})
export class ReqResService {

    constructor(private http: HttpClient) {}

  getDataWithHeader(url, header): any {
    console.log(url)
        return this.http.get<any>(url,header);
  }
  getData(url): any {
    return this.http.get<any>(url);
  }

  
  deleteData(url, body?: any) {
    return this.http.delete<any>(url, body);
  }
  postData(url, obj) {
    return this.http.post<any>(url, obj);
  }
 
    putData(url, obj, id) {
        return this.http.put<any>(url, obj, id);
    }
  postFormData(url: string, formData: FormData) {
    return this.http.post<any>(url, formData);
  }
}
